const EspaciosTabItemFill = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="23"
            viewBox="0 0 26 23"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_417_389)">
                <path
                    d="M17.66 3.35837V1.72837C17.66 1.57837 17.78 1.45837 17.92 1.45837H25.12C25.27 1.45837 25.38 1.57837 25.38 1.72837V5.83837C25.38 5.98837 25.26 6.10837 25.12 6.10837H18.29C18.05 6.10837 17.94 5.80837 18.1 5.63837L19.52 4.16837C19.62 4.05837 19.79 4.05837 19.89 4.16837L20.77 4.60837C20.87 4.71837 21.04 4.71837 21.14 4.60837L22.77 3.38837C22.87 3.27837 23.04 3.27837 23.14 3.38837L23.64 4.10837"
                    stroke="#686058"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.64 3.78833H6.78001C6.78001 3.78833 5.07001 3.84833 4.41001 4.48833C3.70001 5.17833 3.42001 5.61833 3.12001 6.31833C2.83001 6.96833 2.75001 9.02833 2.75001 9.02833H1.06001C1.06001 9.02833 -0.0999905 9.24833 9.45525e-06 10.0483C0.100009 10.8483 1.29001 18.0683 1.29001 18.0683C1.29001 18.0683 1.47001 19.6283 1.90001 19.9083C2.33001 20.1883 3.11001 20.2383 3.52001 20.2383H17.15C17.15 20.2383 18.18 20.2183 18.4 19.9083C18.62 19.5983 18.93 19.1783 18.97 18.7983C19.01 18.4183 20.48 10.6183 20.48 10.6183C20.48 10.6183 20.66 9.60833 20.06 9.48833C19.46 9.36833 17.74 9.43833 17.74 9.43833L17.25 7.17833C17.25 7.17833 16.91 5.66833 16.52 5.05833C16.32 4.74833 15.9 3.84833 13.63 3.79833L13.64 3.78833Z"
                    fill="#686058"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.87 20.7783H6.28L5.96 21.9683C5.88 22.2583 5.59 22.4583 5.26 22.4583H4.9C4.57 22.4583 4.28 22.2583 4.2 21.9683L3.88 20.7783H3.87Z"
                    fill="#686058"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.24 20.7783H16.65L16.33 21.9683C16.25 22.2583 15.96 22.4583 15.63 22.4583H15.27C14.94 22.4583 14.65 22.2583 14.57 21.9683L14.25 20.7783H14.24Z"
                    fill="#686058"
                />
                <path
                    d="M2.51001 9.47829H3.54001C3.54001 9.47829 3.76001 9.44829 4.04001 9.84829C4.26001 10.1583 4.69001 13.0383 4.96001 14.5983C5.03001 15.0083 5.34001 15.3083 5.69001 15.3083L15.25 15.5283C15.59 15.5283 15.88 15.2683 15.97 14.8783C15.97 14.8783 17.07 10.2883 17.18 10.0783C17.29 9.86829 17.83 9.86829 17.83 9.86829"
                    stroke="#686058"
                    strokeMiterlimit="10"
                />
                <path
                    d="M0.410034 20.5383H20.52"
                    stroke="white"
                    strokeWidth="0.75"
                    strokeMiterlimit="10"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.5 8.45839H3.53C3.53 8.45839 3.75 8.42839 4.03 8.89839C4.25 9.26839 4.69 12.6884 4.95 14.5384C5.02 15.0284 5.33 15.3784 5.69 15.3784L15.26 15.6384C15.6 15.6384 15.89 15.3284 15.98 14.8684C15.98 14.8684 17.08 9.41839 17.19 9.16839C17.3 8.91839 17.84 8.91839 17.84 8.91839"
                    fill="#686058"
                />
                <path
                    d="M2.5 8.45839H3.53C3.53 8.45839 3.75 8.42839 4.03 8.89839C4.25 9.26839 4.69 12.6884 4.95 14.5384C5.02 15.0284 5.33 15.3784 5.69 15.3784L15.26 15.6384C15.6 15.6384 15.89 15.3284 15.98 14.8684C15.98 14.8684 17.08 9.41839 17.19 9.16839C17.3 8.91839 17.84 8.91839 17.84 8.91839"
                    stroke="white"
                    strokeMiterlimit="10"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.59 4.64843L18.06 6.10843L24.82 5.76843L23.13 3.38843L20.8 5.52843L19.59 4.64843Z"
                    fill="#686058"
                    stroke="#686058"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_417_389">
                    <rect
                        width="25.89"
                        height="21.5"
                        fill="white"
                        transform="translate(0 0.958374)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export default EspaciosTabItemFill
